<template>
  <div v-if="mode === 'single'" class="nc-text">
    <ClientOnly>
      <div class="tw-flex tw-h-full tw-flex-col tw-justify-center">
        <div class="pm-checkbox-group type-2">
          <input
            v-if="singleCustomValue"
            :id="key"
            v-model="childModelValue"
            :name="name"
            type="checkbox"
            class="pm-checkbox"
            :class="inputClass"
            :value="singleCustomValue"
          />
          <input
            v-else
            :id="key"
            v-model="childModelValue"
            :name="name"
            type="checkbox"
            class="pm-checkbox"
            :class="inputClass"
            :true-value="singleTrueValue"
            :false-value="singleFalseValue"
          />
          <label :for="key">
            <lazy-library-text :text="label"> </lazy-library-text>
          </label>
        </div>
      </div>
    </ClientOnly>
  </div>
  <div v-else-if="mode === 'multiple'" class="nc-text">
    <div v-if="multipleCheckboxLabel" class="tw-mb-1">
      <lazy-library-text :text="multipleCheckboxLabel" tag="span" type="input-label"> </lazy-library-text>
      <span v-if="isRequired" style="color: #ff0000; font-size: 14px">*</span>
    </div>
    <ClientOnly>
      <div class="tw-flex tw-flex-row tw-flex-wrap" style="column-gap: 16px">
        <div
          v-for="(checkbox, index) in multipleCheckboxList"
          :key="`checkbox-${index}`"
          class="tw-flex tw-h-full tw-flex-col tw-justify-center"
        >
          <div class="pm-checkbox-group type-2">
            <input
              :id="`${key}-${index}`"
              v-model="childModelValue"
              :value="checkbox.value"
              :name="name"
              type="checkbox"
              class="pm-checkbox"
              :class="inputClass"
            />
            <label :for="`${key}-${index}`" style="font-weight: 300; font-size: 14px">
              <lazy-library-text :text="checkbox.label"> </lazy-library-text>
            </label>
          </div>
        </div>
      </div>
    </ClientOnly>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { produceKey } from '~/server/core/helpers';

export default defineNuxtComponent({
  name: 'NcCheckbox',

  data() {
    return {
      key: produceKey(),
    };
  },

  props: {
    inputClass: {
      required: false,
      type: String,
      default: '',
    },
    modelValue: {
      required: true,
    },

    label: {
      required: false,
      type: String,
      default: null,
    },

    name: {
      required: false,
      type: String,
      default: null,
    },

    placeholder: {
      required: false,
      type: String,
      default: null,
    },

    isRequired: {
      required: false,
      type: Boolean,
      default: false,
    },

    multipleCheckboxList: {
      required: false,
      type: Array as PropType<{ value: any; label: string }[]>,
      default: () => [],
    },

    multipleCheckboxLabel: {
      required: false,
      type: String,
      default: null,
    },

    singleCustomValue: {
      required: false,
    },

    mode: {
      required: false,
      type: String as PropType<'single' | 'multiple'>,
      default: 'single',
    },

    singleTrueValue: {
      required: false,
      type: Boolean,
      default: true,
    },

    singleFalseValue: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  computed: {
    childModelValue: {
      get() {
        return this.modelValue;
      },
      set(value: string) {
        this.$emit('update:modelValue', value);
      },
    },
  },
});
</script>

<style scoped>
.n-input {
  font-weight: 100;
  font-size: 16px;
  border: 1px solid #aca39a;
}

.n-input input {
  border: none !important;
  padding-left: 30px;
}

.n-input input::placeholder {
  color: var(--input--placeholder);
  font-weight: 100 !important;
}
</style>
